import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { AppVersionGate } from '@/components/app-version-gate';
import { AppLayout } from '@/components/layouts/app-layout';
import { GuestLayout } from '@/components/layouts/guest-layout';
import { AuthProvider } from '@/contexts/auth';
import { CALLBACK_PATH } from '@/features/auth/animal-id';
import { queryClient } from '@/libs/api';
import { AccountPage } from '@/pages/account';
import { AnimalIdCallbackPage } from '@/pages/auth/animal-id-callback';
import { PasswordResetPage } from '@/pages/auth/password-reset';
import { PasswordResetCompletePage } from '@/pages/auth/password-reset-complete';
import { SignIn } from '@/pages/auth/signin';
import { EdiInvitationAcceptPage } from '@/pages/invitation/accept';
import { OrderList } from '@/pages/orders';
import { OrderDetail } from '@/pages/orders/[id]';
import { OrderNew } from '@/pages/orders/new';
import { ProductList } from '@/pages/products';

const AuthenticatedLayout = () => {
  return (
    <AuthProvider>
      <AppLayout />
    </AuthProvider>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppVersionGate />
        <Routes>
          <Route element={<GuestLayout />}>
            <Route path="/signin" element={<SignIn />} />
            {/* アニマルID でのログインの戻り先(API の EDI_UI_BASE_URL/auth/callback) */}
            <Route path={CALLBACK_PATH} element={<AnimalIdCallbackPage />} />
            <Route path="/password/reset" element={<PasswordResetPage />} />
            {/* パスワード再設定メールのリンク先(API の EDI_UI_BASE_URL/reset-password?key=) */}
            <Route path="/reset-password" element={<PasswordResetCompletePage />} />
            <Route path="/invitation/accept/:invitationKey" element={<EdiInvitationAcceptPage />} />
          </Route>
          <Route element={<AuthenticatedLayout />}>
            <Route path="/" element={<Navigate to="/orders" replace />} />
            <Route path="/orders" element={<OrderList />} />
            <Route path="/orders/new" element={<OrderNew />} />
            <Route path="/orders/:id" element={<OrderDetail />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/account" element={<AccountPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/signin" replace />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
